import React,{ useMemo } from "react"

const UseColumnDefs = ({ areaEditorParams }) => {
    
    const columnDefs = useMemo(() => [

    {
            field: "name",
            headerName: "名前",
            filter: "agTextColumnFilter",
        },
        {
            field: "email",
            headerName: "メールアドレス",
            filter: "agTextColumnFilter",
        },
        {
            field: "area",
            displayName: "エリア",
            filter: "agSetColumnFilter",
            cellEditor: "agSelectCellEditor",
            cellEditorParams: areaEditorParams,
        },
        {
            headerName: "",
            cellRenderer: "controlCellRenderer",
            editable: false,
        }
    ], [areaEditorParams])

    return {
        columnDefs
    }

}

export default UseColumnDefs
